@let data = vm();
@let isSuccess = status() === "succeeded";

<iw-info-dialog-content [title]="data.title" [status]="status()">
  <p class="subtitle" afterTitle>
    <span class="subtitle-text" [class.no-wrap]="isSuccess">{{
      data.subtitle
    }}</span>

    @if (isSuccess) {
      <span class="text-ellipsis" [title]="operationId()">{{
        operationId()
      }}</span>
      <iw-button
        class="copy-btn"
        size="s"
        uiType="custom"
        [onlyIcon]="true"
        (click)="onCopy(operationId())"
        ><fu-icon iconName="copy" size="16" />
      </iw-button>
    }
  </p>
</iw-info-dialog-content>
